var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RMapMyLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,5 A19,19 0,1 0,24,43 A19,19 0,1 0,24,5",
    fill: "#7C1CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24,12 A12,12 0,1 0,24,36 A12,12 0,1 0,24,12",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24,18 A6,6 0,1 0,24,30 A6,6 0,1 0,24,18",
    fill: "#0D0D12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22,3 H26 V11 H22 Z M22,37 H26 V45 H22 Z M3,22 H11 V26 H3 Z M37,22 H45 V26 H37 Z",
    fill: "#00D4FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24,21 A3,3 0,1 0,24,27 A3,3 0,1 0,24,21",
    fill: "#FFD000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RMapMyLocation);
export default __webpack_public_path__ + "static/media/p4r_map_my_location.64790277a4dfad2de79b114d076e8df0.svg";
export { ForwardRef as ReactComponent };